function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 -14.9768L80.75 -15L80.7442 11.6929C78.3171 14.9945 74.2472 16.3875 68.5343 15.8719C59.9649 15.0988 44.9198 8.13749 27.9438 8.13749C16.6264 8.13749 7.56184 11.8028 0.75 19.1333V-14.9768Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M57.5921 38.842C56.1184 38.842 54.9395 39.8526 54.5605 41.1578H50.1395C49.6763 41.1578 49.2974 41.5368 49.2974 41.9999C49.2974 42.4631 49.6763 42.842 50.1395 42.842H54.5605C54.9395 44.1894 56.1605 45.1578 57.5921 45.1578C59.3184 45.1578 60.75 43.7263 60.75 41.9999C60.75 40.2736 59.3184 38.842 57.5921 38.842Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M47.4027 36.1896C47.6132 36.1896 47.8237 36.1054 47.9921 35.937L51.1079 32.8212C52.329 33.4949 53.8869 33.3686 54.8974 32.316C56.1184 31.0949 56.1184 29.0739 54.8974 27.8528C53.6763 26.6317 51.6553 26.6317 50.4342 27.8528C49.4237 28.8633 49.2553 30.4633 49.929 31.6423L46.8132 34.7581C46.4763 35.0949 46.4763 35.6002 46.8132 35.937C46.9816 36.1054 47.1921 36.1896 47.4027 36.1896Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M39.908 28.1895V32.6105C39.908 33.0737 40.2869 33.4526 40.7501 33.4526C41.2132 33.4526 41.5922 33.0737 41.5922 32.6105V28.1895C42.9395 27.8105 43.908 26.5895 43.908 25.1579C43.908 23.4316 42.4764 22 40.7501 22C39.0237 22 37.5922 23.4316 37.5922 25.1579C37.5922 26.6316 38.5606 27.8526 39.908 28.1895Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M30.3922 32.8212L33.5079 35.937C33.6764 36.1054 33.8869 36.1896 34.0974 36.1896C34.3079 36.1896 34.5185 36.1054 34.6869 35.937C35.0237 35.6002 35.0237 35.0949 34.6869 34.7581L31.5711 31.6423C32.2448 30.4212 32.1185 28.8633 31.0658 27.8528C29.8448 26.6317 27.8237 26.6317 26.6027 27.8528C25.3816 29.0739 25.3816 31.0949 26.6027 32.316C27.6553 33.3686 29.2132 33.4949 30.3922 32.8212Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9395 42.842H31.3605C31.8237 42.842 32.2026 42.4631 32.2026 41.9999C32.2026 41.5368 31.8237 41.1578 31.3605 41.1578H26.9395C26.5605 39.8105 25.3395 38.842 23.9079 38.842C22.1816 38.842 20.75 40.2736 20.75 41.9999C20.75 43.7263 22.1816 45.1578 23.9079 45.1578C25.3816 45.1578 26.6026 44.1894 26.9395 42.842Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5499 48.0632L30.4341 51.179C29.2131 50.5053 27.6552 50.6316 26.6447 51.6842C25.4236 52.9053 25.4236 54.9263 26.6447 56.1474C27.8657 57.3684 29.8868 57.3684 31.1078 56.1474C32.1184 55.1369 32.2868 53.5369 31.6131 52.3579L34.7289 49.2421C35.0657 48.9053 35.0657 48.4 34.7289 48.0632C34.392 47.7263 33.8447 47.7263 33.5499 48.0632Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5922 55.8105V51.3895C41.5922 50.9263 41.2132 50.5474 40.7501 50.5474C40.2869 50.5474 39.908 50.9263 39.908 51.3895V55.8105C38.5606 56.1895 37.5922 57.4105 37.5922 58.8421C37.5922 60.5684 39.0237 62 40.7501 62C42.4764 62 43.908 60.5684 43.908 58.8421C43.908 57.3684 42.9395 56.1474 41.5922 55.8105Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M51.1079 51.179L47.9921 48.0632C47.6553 47.7263 47.15 47.7263 46.8132 48.0632C46.4763 48.4 46.4763 48.9053 46.8132 49.2421L49.929 52.3579C49.2553 53.579 49.3816 55.1369 50.4342 56.1474C51.6553 57.3684 53.6763 57.3684 54.8974 56.1474C56.1184 54.9263 56.1184 52.9053 54.8974 51.6842C53.8448 50.6316 52.2869 50.5053 51.1079 51.179Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M40.75 35.0947C36.9605 35.0947 33.8447 38.1684 33.8447 42C33.8447 45.8316 36.9605 48.9053 40.75 48.9053C44.5395 48.9053 47.6553 45.7895 47.6553 42C47.6553 38.2105 44.5395 35.0947 40.75 35.0947ZM43.5289 42.4631L41.0026 44.9895C40.8763 45.1158 40.6658 45.1158 40.5395 44.9895L38.0553 42.5053C37.4658 41.9158 37.3395 40.9895 37.8026 40.3158C38.4342 39.3895 39.6553 39.3053 40.4131 40.0631L40.7921 40.4421L41.1289 40.1053C41.7184 39.5158 42.6447 39.3895 43.3184 39.8526C44.1605 40.4842 44.2447 41.7474 43.5289 42.4631Z",
  fill: "black"
});

var SvgSupport = function SvgSupport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -15,
    width: 81,
    height: 35
  }, _ref4), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 13.4673V18.4614L40.75 15.9644L0.75 13.4673Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8058 15.9271L40.8156 15.9192L40.7979 15.9209L40.7917 15.9254L40.8058 15.9271Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9001 15.9324L80.75 18.4197V13.4275L41.0245 15.9058L40.9001 15.9324Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7838 15.9254L40.7874 15.9209L40.7767 15.9218L40.775 15.9245L40.7838 15.9254Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7579 15.9226H40.7526V15.9245H40.7579V15.9226Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8505 15.9298L40.8957 15.9138L40.8407 15.9172L40.8202 15.9279L40.8505 15.9298Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7677 15.9199H40.7651V15.927H40.7677V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 24.4789V29.831L40.75 15.9644L0.75 24.4789Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9645L40.9002 15.9325L40.8505 15.9299L40.75 15.9645Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0244 15.9058L80.75 7.4499V2.09875L40.8958 15.9139L41.0244 15.9058Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8958 15.9139L40.8503 15.9299L40.9 15.9324L41.0244 15.9058L40.8958 15.9139Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8946 31.6591L40.75 15.9644L10.5713 31.6591H17.8946Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8406 15.9173L80.75 -4.83813V-11.5032L40.8157 15.9192L40.8406 15.9173Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8059 15.927L40.75 15.9643L40.8202 15.9279L40.8059 15.927Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8202 15.9279L40.8407 15.9172L40.816 15.9192L40.8062 15.9271L40.8202 15.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3684 31.6591L40.7499 15.9644L23.7343 31.6591H27.3684Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.798 15.9209L80.75 -20.9291V-25.6389H76.2224L40.7874 15.9209H40.798Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7837 15.9253L40.75 15.9643L40.7918 15.9253H40.7837Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7918 15.9254L40.798 15.9209H40.7873L40.7837 15.9254H40.7918Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2054 31.6591L40.7499 15.9644L30.7866 31.6591H33.2054Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7766 15.9218L67.1586 -25.6389H60.7523L40.7695 15.9218H40.7766Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7686 15.9246L40.75 15.9645L40.775 15.9246H40.7686Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7748 15.9199H40.7714V15.927H40.7748V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6613 31.6591L40.75 15.9644L35.7202 31.6591H37.6613Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7633 15.9226L54.0836 -25.6389H48.9367L40.7579 15.9226H40.7633Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7579 15.9246L40.75 15.9645L40.7632 15.9246H40.7579Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7615 15.9209H40.7598V15.9262H40.7615V15.9209Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6571 31.6591L40.75 15.9644L39.844 31.6591H41.6571Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7525 15.9246L40.7499 15.9237L40.7525 15.9226L43.1502 -25.6389H38.3506L40.7499 15.9645L40.7525 15.9246Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9236L40.7524 15.9244V15.9226L40.75 15.9236Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7806 31.6591L40.75 15.9644L43.8386 31.6591H45.7806Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5641 -25.6389H27.4172L40.7499 15.9645L32.5641 -25.6389Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7125 31.6591L40.75 15.9644L48.2954 31.6591H50.7125Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7496 -25.6389H14.3413L40.7501 15.9645L20.7496 -25.6389Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7665 31.6591L40.75 15.9644L54.1307 31.6591H57.7665Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27774 -25.639H0.75V-20.9301L40.75 15.9643L5.27774 -25.639Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9279 31.6591L40.75 15.9644L63.6055 31.6591H70.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 -11.5032V-4.83813L40.75 15.9644L0.75 -11.5032Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75 29.831V24.4789L40.75 15.9644L80.75 29.831Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.0979V7.44992L40.75 15.9645L0.75 2.0979Z",
    style: {
      fill: "var(--color-primary)"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 40.55,
    cy: 41.3999,
    r: 5,
    style: {
      fill: "var(--color-primary)"
    }
  }), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSupport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/support.5d2012a4.svg";
export { ForwardRef as ReactComponent };